export const getOrganizationFieldsLabelMap = () => {
  return {
    'tags': 'stripes-acq-components.label.tags',
    'tags.tagList': 'stripes-acq-components.label.tags',
    'tags.tagList[\\d]': 'stripes-acq-components.label.tags',

    'metadata.createdByUserId': 'ui-organizations.metadata.createdByUserId',
    'metadata.createdDate': 'ui-organizations.metadata.createdDate',
    'metadata.updatedByUserId': 'ui-organizations.metadata.updatedByUserId',
    'metadata.updatedDate': 'ui-organizations.metadata.updatedDate',

    'name': 'ui-organizations.summary.name',
    'code': 'ui-organizations.summary.code',
    'description': 'ui-organizations.summary.description',
    'exportToAccounting': 'ui-organizations.vendorInfo.exportToAccounting',
    'status': 'ui-organizations.summary.organizationStatus',
    'organizationTypes': 'ui-organizations.summary.type',
    'organizationTypes[\\d]': 'ui-organizations.summary.type',
    'language': 'ui-organizations.summary.defaultLanguage',
    'aliases': 'ui-organizations.summary.alternativeNames',
    'aliases[\\d]': 'ui-organizations.summary.alternativeNames',
    'aliases[\\d].value': 'ui-organizations.search.aliases',
    'aliases[\\d].description': 'ui-organizations.versionHistory.field.alias.description',

    'addresses': 'ui-organizations.data.contactTypes.address',
    'addresses[\\d]': 'ui-organizations.data.contactTypes.address',
    'addresses[\\d].addressLine1': 'ui-organizations.contactPeople.addressLine1',
    'addresses[\\d].addressLine2': 'ui-organizations.contactPeople.addressLine2',
    'addresses[\\d].city': 'ui-organizations.contactPeople.city',
    'addresses[\\d].stateRegion': 'ui-organizations.contactPeople.stateRegion',
    'addresses[\\d].zipCode': 'ui-organizations.contactPeople.zipCode',
    'addresses[\\d].country': 'ui-organizations.contactPeople.country',
    'addresses[\\d].isPrimary': 'ui-organizations.versionHistory.field.address.isPrimary',
    'addresses[\\d].categories': 'ui-organizations.versionHistory.field.address.categories',
    'addresses[\\d].categories[\\d]': 'ui-organizations.versionHistory.field.address.categories',
    'addresses[\\d].language': 'ui-organizations.versionHistory.field.address.language',
    'phoneNumbers': 'ui-organizations.contactPeople.phoneNumbers',
    'phoneNumbers[\\d]': 'ui-organizations.contactPeople.phoneNumbers',
    'phoneNumbers[\\d].phoneNumber': 'ui-organizations.contactPeople.phoneNumber',
    'phoneNumbers[\\d].categories': 'ui-organizations.versionHistory.field.phoneNumbers.categories',
    'phoneNumbers[\\d].categories[\\d]': 'ui-organizations.versionHistory.field.phoneNumbers.categories',
    'phoneNumbers[\\d].type': 'ui-organizations.versionHistory.field.phoneNumbers.type',
    'phoneNumbers[\\d].isPrimary': 'ui-organizations.versionHistory.field.phoneNumbers.isPrimary',
    'phoneNumbers[\\d].language': 'ui-organizations.contactPeople.language',
    'emails': 'ui-organizations.contactPeople.emails',
    'emails[\\d]': 'ui-organizations.contactPeople.emails',
    'emails[\\d].value': 'ui-organizations.contactPeople.emailAddress',
    'emails[\\d].description': 'ui-organizations.versionHistory.field.emails.description',
    'emails[\\d].isPrimary': 'ui-organizations.versionHistory.field.emails.isPrimary',
    'emails[\\d].categories': 'ui-organizations.versionHistory.field.emails.categories',
    'emails[\\d].categories[\\d]': 'ui-organizations.versionHistory.field.emails.categories',
    'emails[\\d].language': 'ui-organizations.versionHistory.field.emails.language',
    'urls': 'ui-organizations.contactPeople.urls',
    'urls[\\d]': 'ui-organizations.contactPeople.urls',
    'urls[\\d].value': 'ui-organizations.contactPeople.url',
    'urls[\\d].description': 'ui-organizations.versionHistory.field.urls.description',
    'urls[\\d].language': 'ui-organizations.versionHistory.field.urls.language',
    'urls[\\d].isPrimary': 'ui-organizations.versionHistory.field.urls.isPrimary',
    'urls[\\d].categories': 'ui-organizations.versionHistory.field.urls.categories',
    'urls[\\d].categories[\\d]': 'ui-organizations.versionHistory.field.urls.categories',

    'contacts': 'ui-organizations.contactPeople',
    'contacts[\\d]': 'ui-organizations.contactPeople',
    'privilegedContacts': 'ui-organizations.privilegedDonorInformation',
    'agreements': 'ui-organizations.linkedAgreements.section',
    'agreements[\\d]': 'ui-organizations.linkedAgreements.section',
    'agreements[\\d].name': 'ui-organizations.versionHistory.field.agreements.name',
    'agreements[\\d].discount': 'ui-organizations.agreement.discount',
    'agreements[\\d].referenceUrl': 'ui-organizations.agreement.referenceUrl',
    'agreements[\\d].notes': 'ui-organizations.versionHistory.field.agreements.notes',
    'erpCode': 'ui-organizations.summary.accountingCode',
    'paymentMethod': 'ui-organizations.accounts.paymentMethod',
    'accessProvider': 'ui-organizations.versionHistory.field.accessProvider',
    'governmental': 'ui-organizations.versionHistory.field.governmental',
    'licensor': 'ui-organizations.versionHistory.field.governmental',
    'materialSupplier': 'ui-organizations.versionHistory.field.materialSupplier',
    'vendorCurrencies': 'ui-organizations.vendorInfo.vendorCurrencies',
    'vendorCurrencies[\\d]': 'ui-organizations.vendorInfo.vendorCurrencies',
    'claimingInterval': 'ui-organizations.vendorInfo.claimingInterval',
    'discountPercent': 'ui-organizations.vendorInfo.discountPercent',
    'expectedActivationInterval': 'ui-organizations.vendorInfo.expectedActivationInterval',
    'expectedInvoiceInterval': 'ui-organizations.vendorInfo.expectedInvoiceInterval',
    'renewalActivationInterval': 'ui-organizations.vendorInfo.renewalActivationInterval',
    'subscriptionInterval': 'ui-organizations.vendorInfo.subscriptionInterval',
    'expectedReceiptInterval': 'ui-organizations.vendorInfo.expectedReceiptInterval',
    'taxId': 'ui-organizations.vendorInfo.taxID',
    'liableForVat': 'ui-organizations.vendorInfo.liableForVAT',
    'taxPercentage': 'ui-organizations.vendorInfo.taxPercentage',
    'interfaces': 'ui-organizations.interface',
    'interfaces[\\d]': 'ui-organizations.interface',

    'edi': 'ui-organizations.integration.edi',
    'edi.vendorEdiCode': 'ui-organizations.integration.edi.vendorEDICode',
    'edi.vendorEdiType': 'ui-organizations.integration.edi.vendorEDIType',
    'edi.libEdiCode': 'ui-organizations.integration.edi.libraryEDICode',
    'edi.libEdiType': 'ui-organizations.integration.edi.libraryEDIType',
    'edi.prorateTax': 'ui-organizations.versionHistory.field.edi.prorateTax',
    'edi.prorateFees': 'ui-organizations.versionHistory.field.edi.prorateFees',
    'edi.ediNamingConvention': 'ui-organizations.integration.edi.ediNamingConvention',
    'edi.sendAcctNum': 'integration.edi.sendAccountNumber',
    'edi.supportOrder': 'ui-organizations.integration.edi.orders',
    'edi.supportInvoice': 'ui-organizations.integration.edi.invoices',
    'edi.notes': 'ui-organizations.versionHistory.field.edi.notes',
    'edi.ediFtp': 'ui-organizations.integration.ftp',
    'edi.ediFtp.ftpFormat': 'ui-organizations.integration.ftp.ftpFormat',
    'edi.ediFtp.serverAddress': 'ui-organizations.integration.ftp.serverAddress',
    'edi.ediFtp.username': 'ui-organizations.integration.ftp.username',
    'edi.ediFtp.password': 'ui-organizations.edit.password', // NOSONAR - it's a label mapping, not the actual password
    'edi.ediFtp.ftpMode': 'ui-organizations.integration.ftp.ftpMode',
    'edi.ediFtp.ftpConnMode': 'ui-organizations.integration.ftp.ftpConnectionMode',
    'edi.ediFtp.ftpPort': 'ui-organizations.integration.ftp.ftpPort',
    'edi.ediFtp.orderDirectory': 'ui-organizations.integration.ftp.orderDirectory',
    'edi.ediFtp.invoiceDirectory': 'ui-organizations.integration.ftp.invoiceDirectory',
    'edi.ediFtp.notes': 'ui-organizations.integration.ftp.notes',
    'edi.ediJob': 'ui-organizations.integration.scheduling',
    'edi.ediJob.scheduleEdi': 'ui-organizations.integration.scheduling.scheduleEDI',
    'edi.ediJob.schedulingDate': 'ui-organizations.integration.scheduling.scheduleDate',
    'edi.ediJob.time': 'ui-organizations.integration.scheduling.scheduleTime',
    'edi.ediJob.isMonday': 'ui-organizations.integration.scheduling.scheduleWeekdays.MONDAY',
    'edi.ediJob.isTuesday': 'ui-organizations.integration.scheduling.scheduleWeekdays.TUESDAY',
    'edi.ediJob.isWednesday': 'ui-organizations.integration.scheduling.scheduleWeekdays.WEDNESDAY',
    'edi.ediJob.isThursday': 'ui-organizations.integration.scheduling.scheduleWeekdays.THURSDAY',
    'edi.ediJob.isFriday': 'ui-organizations.integration.scheduling.scheduleWeekdays.FRIDAY',
    'edi.ediJob.isSaturday': 'ui-organizations.integration.scheduling.scheduleWeekdays.SATURDAY',
    'edi.ediJob.isSunday': 'ui-organizations.integration.scheduling.scheduleWeekdays.SUNDAY',
    'edi.ediJob.sendToEmails': 'ui-organizations.versionHistory.field.edi.ediJob.sendToEmails',
    'edi.ediJob.notifyAllEdi': 'ui-organizations.versionHistory.field.edi.ediJob.notifyAllEdi',
    'edi.ediJob.notifyInvoiceOnly': 'ui-organizations.versionHistory.field.edi.ediJob.notifyInvoiceOnly',
    'edi.ediJob.notifyErrorOnly': 'ui-organizations.versionHistory.field.edi.ediJob.notifyErrorOnly',
    'edi.ediJob.schedulingNotes': 'ui-organizations.versionHistory.field.edi.ediJob.schedulingNotes',

    'accounts': 'ui-organizations.accounts',
    'accounts[\\d]': 'ui-organizations.accounts',
    'accounts[\\d].name': 'ui-organizations.accounts.name',
    'accounts[\\d].accountNo': 'ui-organizations.accounts.accountNumber',
    'accounts[\\d].description': 'ui-organizations.accounts.description',
    'accounts[\\d].appSystemNo': 'ui-organizations.accounts.payable',
    'accounts[\\d].paymentMethod': 'ui-organizations.accounts.paymentMethod',
    'accounts[\\d].accountStatus': 'ui-organizations.accounts.account.accountStatus',
    'accounts[\\d].contactInfo': 'ui-organizations.accounts.account.contactInfo',
    'accounts[\\d].libraryCode': 'ui-organizations.accounts.libraryCode',
    'accounts[\\d].libraryEdiCode': 'ui-organizations.accounts.libraryEDICode',
    'accounts[\\d].notes': 'ui-organizations.accounts.notes',
    'accounts[\\d].acqUnitIds': 'ui-organizations.versionHistory.field.accounts.acqUnitsIds',
    'accounts[\\d].acqUnitIds[\\d]': 'ui-organizations.versionHistory.field.accounts.acqUnitsIds',

    'isVendor': 'ui-organizations.summary.isVendor',
    'isDonor': 'ui-organizations.summary.isDonor',
    'sanCode': 'ui-organizations.versionHistory.field.sanCode',
    'acqUnitIds': 'stripes-acq-components.label.acqUnits',
    'acqUnitIds[\\d]': 'stripes-acq-components.label.acqUnits',
  };
};
